export default __webpack_public_path__ + "static/media/symmetra-teleporter.fd96367d.mp3";